export enum UomActionTypes {
  SelectDimension = '[UoM] Select Dimension',
  ResetUomState = '[UoM] Reset State',
}
